import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { addSDRCurriculamTimeline, addSDRSummit, getSDRCurriculamTimeline, getSDRSummit } from "./SdrPageSubtitesAPi";


const initialState: any = {
  loading: {
    add_summit: false,
    get_summit: false,
    add_timeline: false,
    get_timeline: false,
  },
  req_success: {
    add_summit: false,
    get_summit: false,
    add_timeline: false,
    get_timeline: false,
  },
  sdr_summit: {},
  sdr_timeline: {},
};
// addPDMSummit
const SdrPageSubtitlesSlice = createSlice({
  name: "SdrPageSubtitlesSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //  addPDMSummit
    builder.addCase(addSDRSummit.pending, (state) => {
      state.loading.add_summit = true;
      state.req_success.add_summit = false;
    });
    builder.addCase(
      addSDRSummit.fulfilled,
      (state, { payload }: PayloadAction<any>) => {
        state.loading.add_summit = false;
        state.req_success.add_summit = true;
        state.sdr_summit = payload.data;
      }
    );
    builder.addCase(addSDRSummit.rejected, (state) => {
      state.loading.add_summit = false;
    });

    // getPDMSummit
    builder.addCase(getSDRSummit.pending, (state) => {
      state.loading.get_summit = true;
      state.req_success.get_summit = false;
      state.req_success.add_summit = false;
    });
    builder.addCase(
      getSDRSummit.fulfilled,
      (state, { payload }: PayloadAction<any>) => {
        state.loading.get_summit = false;
        state.req_success.get_summit = true;
        state.req_success.add_summit = true;
        state.sdr_summit = payload.data;
      }
    );
    builder.addCase(getSDRSummit.rejected, (state) => {
      state.loading.get_summit = false;
      state.req_success.add_summit = false;
    });

    builder.addCase(addSDRCurriculamTimeline.pending, (state) => {
      state.loading.add_timeline = true;
      state.req_success.add_timeline = false;
    });
    builder.addCase(
      addSDRCurriculamTimeline.fulfilled,
      (state, { payload }: PayloadAction<any>) => {
        state.loading.add_timeline = false;
        state.req_success.add_timeline = true;
        state.sdr_timeline = payload.data;
      }
    );
    builder.addCase(addSDRCurriculamTimeline.rejected, (state) => {
      state.loading.add_timeline = false;
    });

    builder.addCase(getSDRCurriculamTimeline.pending, (state) => {
      state.loading.get_timeline = true;
      state.req_success.get_timeline = false;
    });
    builder.addCase(
      getSDRCurriculamTimeline.fulfilled,
      (state, { payload }: PayloadAction<any>) => {
        state.loading.get_timeline = false;
        state.req_success.get_timeline = true;
        state.req_success.add_timeline = true;
        state.sdr_timeline = payload.data;
      }
    );
    builder.addCase(getSDRCurriculamTimeline.rejected, (state) => {
      state.loading.get_timeline = false;
    });
  },
});
export default SdrPageSubtitlesSlice.reducer;
